import { SubmissionError } from 'redux-form';

const jsonLdMimeType = 'application/ld+json';

export default function (url, options = {}) {
  if ('undefined' === typeof options.headers) options.headers = new Headers();
  if (null === options.headers.get('Accept')) options.headers.set('Accept', jsonLdMimeType);

  if ('undefined' !== options.body && !(options.body instanceof FormData) && null === options.headers.get('Content-Type')) {
    options.headers.set('Content-Type', jsonLdMimeType);
  }

  const link = url.includes(process.env.REACT_APP_API_PATH) ? process.env.REACT_APP_API_HOST + url : process.env.REACT_APP_API_HOST + process.env.REACT_APP_API_PATH + url;

  let token = localStorage.getItem('betwidgets_login_token');
  if (token) {
    options.headers.set('Authorization', `Bearer ${token}`)
  }
  return fetch(link, options).then(response => {
    if (response.ok) return response;
    if (response.status === 401 ) {
      localStorage.removeItem('betwidgets_login_token');
      throw Error('Token Expired, please logout and log in again');
    }
    return response
      .json()
      .then(json => {
        const error = json['description'] ? json['description'] : response.statusText;
        if (!json.violations) throw Error(error);

        let errors = {_error: error};
        json.violations.map((violation) => errors[violation.propertyPath] = violation.message);

        throw new SubmissionError(errors);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js